import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import axios from 'axios'
import ReactGA from 'react-ga4'
import { 
    Button, 
    TextField, 
    Container, 
    Paper, 
    Typography, 
    Box,
    Stack,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions
} from '@mui/material'
import SEO from '../components/SEO'

function ResetPassword() {
    ReactGA.send({ hitType: "pageview", page: window.location.pathname })

    const [email, setEmail] = useState('')
    const [showModal, setShowModal] = useState(false)

    const history = useNavigate()

    const handleCloseModal = () => {
        setShowModal(false)
        history('/')
    }

    const submitHandler = async (e) => {
        e.preventDefault()

        const config = {
            headers: {
                'Content-type': 'application/json',
            }
        }

        try {
            await axios.post(
                '/api/users/reset',
                { email },
                config
            )
            setShowModal(true)
        } catch (error) {
            console.error('Error resetting password:', error)
            // You might want to show an error message to the user here
        }
    }

    return (
        <>
            <SEO 
                title="Reset Password - PCR Assistant"
                description="Reset your PCR Assistant account password. Follow our secure password reset process to regain access to your account."
                canonicalUrl="/resetpwd"
            />
            <Container maxWidth="sm">
                <Box sx={{ mt: 8, mb: 4 }}>
                    <Paper elevation={3} sx={{ p: 4 }}>
                        <Typography variant="h4" component="h1" align="center" gutterBottom>
                            Reset Password
                        </Typography>

                        <Box component="form" onSubmit={submitHandler} sx={{ mt: 3 }}>
                            <Stack spacing={3}>
                                <TextField
                                    label="Email Address"
                                    type="email"
                                    fullWidth
                                    required
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                />

                                <Button 
                                    type="submit" 
                                    variant="contained" 
                                    fullWidth
                                    size="large"
                                >
                                    Reset Password
                                </Button>
                            </Stack>
                        </Box>
                    </Paper>
                </Box>

                <Dialog
                    open={showModal}
                    onClose={handleCloseModal}
                >
                    <DialogTitle>Reset Password</DialogTitle>
                    <DialogContent>
                        <Typography>
                            You should receive an email with a link that you can use to reset your password.
                        </Typography>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleCloseModal} variant="contained">
                            OK
                        </Button>
                    </DialogActions>
                </Dialog>
            </Container>
        </>
    )
}

export default ResetPassword
